import React from 'react';
import { FormattedDate, FormattedTime } from 'react-intl';
import { styled } from '@linaria/react';
import { Icon } from '@daedalus/atlas/Icon';
import { Text } from '@daedalus/atlas/Text';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
interface Props {
  expiresAt?: string;
}
const List = /*#__PURE__*/styled('div')({
  name: "List",
  class: "lswpp8",
  propsAsIs: false
});
const ListItem = /*#__PURE__*/styled('div')({
  name: "ListItem",
  class: "l1rf6ncg",
  propsAsIs: false
});
const _exp5 = /*#__PURE__*/() => Icon;
const CustomIcon = /*#__PURE__*/styled(_exp5())({
  name: "CustomIcon",
  class: "cmsdawx",
  propsAsIs: true
});
export const NextSteps = ({
  expiresAt
}: Props) => {
  const expireAt = expiresAt && new Date(expiresAt);
  return <div>
      <Text variant="titleL">
        <FormattedMessageWrapper id="dealFreeze.whatHappensNext" defaultMessage="What happens next:" />
      </Text>
      <List>
        <ListItem>
          <CustomIcon name="CalendarCheck4" />
          <Text variant="bodyS">
            <FormattedMessageWrapper id="dealFreeze.bookBeforeExpiration" defaultMessage="Complete booking by {date} ({time}) <br></br> or the deal expires and the price may increase." values={{
            date: <FormattedDate value={expireAt} weekday="short" month="short" day="2-digit" />,
            time: <FormattedTime value={expireAt} hour12={false} hour="numeric" minute="2-digit" timeZone="CET" timeZoneName="short" />,
            br: () => <br />
          }} />
          </Text>
        </ListItem>

        <ListItem>
          <CustomIcon name="Mail" />
          <Text variant="bodyS">
            <FormattedMessageWrapper id="dealFreeze.checkYourEmail" defaultMessage="We'll send you an email reminder before the deal expires." />
          </Text>
        </ListItem>

        <ListItem>
          <CustomIcon name="FaceWink" />
          <Text variant="bodyS">
            <FormattedMessageWrapper id="dealFreeze.payTheLowerPrice" defaultMessage="Pay the lower price if it drops before you book." />
          </Text>
        </ListItem>
      </List>
    </div>;
};

require("./NextSteps.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./NextSteps.tsx");